/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';
import OrgAppForm from './OrgAppForm';
import { getAllAppsByOrgID, getAllOrgsApps } from '../../../../../../../store/reducers/organization/orgApp/orgAppAction';
import { editOrgApp } from '../../../../../../../services/organization/OrgApp';
import { useParams } from 'react-router-dom';

const OrgAppEdit = ({ handleClose, selectedOrgApp }) => {
    const dispatch = useDispatch();
    const { orgid } = useParams();

    const handleSubmit = async ({ detailName, detailValue }, { setSubmitting }) => {
        try {
            setSubmitting(true)

            await editOrgApp({
                organizationApplicationID: selectedOrgApp.organizationApplicationID,

                organizationApplicationDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            if (orgid) {
                await dispatch(getAllAppsByOrgID({ 'organizationID': orgid })).unwrap()
            } else {
                await dispatch(getAllOrgsApps()).unwrap();

            }
            setSubmitting(false)
            toast.success('Organization Application was edited successfully');
            handleClose();
        } catch (error) {
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Edit</Typography>
            <Formik
                initialValues={{
                    detailName: selectedOrgApp.organizationApplicationDetails[0].detailName,
                    detailValue: selectedOrgApp.organizationApplicationDetails[0].detailValue,

                }}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgAppForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAppEdit;